import MotivationCardDragGame from './MotivationCardDragGame';

export default MotivationCardDragGame;
